module.exports = __webpack_public_path__ + "img/horizontal_3_7_pp12_7016.608fb606.png";